import { connect } from 'react-redux';
import { toggleFeaturesModal } from 'project/ducks/features';
import Collaborators from 'project/components/collaborators';

export function mapStateToProps({ project: { collaborators } }) {
  return {
    ...collaborators.data,
  };
}

export default connect(mapStateToProps, {
  toggleFeaturesModal
})(Collaborators);



// WEBPACK FOOTER //
// ./project/containers/collaborators.js